export default "__VITE_ASSET__DBrLuf7g__"